import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import companySlice from './slices/companySlice';
import meetingSlice from './slices/meetingSlice';
import profileDataSlice from './slices/profileSlice';
import draftMessages from './slices/chatSlice';
import notificationSlice from './slices/notificationSlice';
import meetingChatSlice from './slices/meetingChatSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    company: companySlice,
    meeting: meetingSlice,
    profileDetails: profileDataSlice,
    draftMessages: draftMessages,
    notification: notificationSlice,
    meetingChat: meetingChatSlice,
  },
});